// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1AH2W","footer":"ModalError_footer__3MGGN"};